import { defineStore } from 'pinia';

import type { Deduction } from '@stuut/api/models';

interface State {
  deductions: Deduction[];
}

export const useDeductions = defineStore('deductions', {
  getters: {
    getById: (state) => {
      return (deductionId: string) =>
        state.deductions.find((deduction) => deduction.id === deductionId) as Deduction | undefined;
    },
  },
  state: (): State => ({
    deductions: [],
  }),
});

export default useDeductions;
